import { version } from '../version'

export const GOTO_SHELL_VERSION = version
